"use client";
import React from "react";
import {
  PaginationContent,
  PaginationItem,
  PaginationPrevious,
  PaginationLink,
  PaginationEllipsis,
  PaginationNext,
  Pagination as PaginationComponent,
} from "./ui/pagination";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import noop from "lodash/noop";

const Pagination = ({
  count = 0,
  size,
  page,
}: {
  count?: number;
  size: number;
  page: number;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { push } = useRouter();

  const searchParamsObject: Record<string, unknown> = {};

  searchParams.forEach((value, key) => {
    searchParamsObject[key] = value;
  });

  const numberOfPages = Math.ceil(count / size);

  const previousPath =
    page > 0
      ? Object.entries({ ...searchParamsObject, page: page - 1 })
          .map((e) => `${e[0]}=${e[1]}`)
          .join("&")
      : "#";

  const nextPath =
    page < numberOfPages
      ? Object.entries({ ...searchParamsObject, page: page + 1 })
          .map((e) => `${e[0]}=${e[1]}`)
          .join("&")
      : "#";

  const handleSelectSize = (value: string) => {
    const path = Object.entries({ ...searchParamsObject, size: value })
      .map((e) => `${e[0]}=${e[1]}`)
      .join("&");

    push(`${pathname}?${path}`);
  };

  return (
    <PaginationComponent className="flex justify-between items-center p-2">
      <div className="flex items-center">
        <div className="w-20 hidden lg:block">
          <Select onValueChange={handleSelectSize} defaultValue={String(size)}>
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem key={10} value={String(10)} onChange={noop}>
                {10}
              </SelectItem>
              <SelectItem key={30} value={String(30)} onChange={noop}>
                {30}
              </SelectItem>
              <SelectItem key={50} value={String(50)} onChange={noop}>
                {50}
              </SelectItem>
            </SelectContent>
          </Select>
        </div>

        <p className="lg:hidden">{size}</p>

        <p className="ml-1">
          {"－ sur "}
          {count}
        </p>
      </div>

      <PaginationContent>
        {page > 1 && (
          <>
            <PaginationItem>
              <PaginationPrevious href={`${pathname}?${previousPath}`} />
            </PaginationItem>

            <PaginationItem>
              <PaginationLink href={`${pathname}?${previousPath}`}>
                {page - 1}
              </PaginationLink>
            </PaginationItem>
          </>
        )}

        <PaginationItem>
          <PaginationLink href="#" isActive>
            {page}
          </PaginationLink>
        </PaginationItem>

        {page < numberOfPages && (
          <>
            <PaginationItem>
              <PaginationLink href={`${pathname}?${nextPath}`}>
                {page + 1}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationNext href={`${pathname}?${nextPath}`} />
            </PaginationItem>
          </>
        )}
      </PaginationContent>
    </PaginationComponent>
  );
};

export default Pagination;
